/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-29 14:06:28
 */
// const msgServer = () => import("@/views/de-product/msg-server/msg-server.vue");
// const msgBuy = () =>
//   import("@/views/de-product/msg-server/children/msg-buy/msg-buy.vue");
// const msgRecharge = () =>
//   import(
//     "@/views/de-product/msg-server/children/msg-recharge/msg-recharge.vue"
//   );
// const msgBuyRecord = () =>
//   import("@/views/de-product/msg-buy-record/msg-buy-record.vue");
const interFlow = () => import("@/views/de-product/interflow/interflow.vue");
const interfaceMember = () => import("@/views/de-product/interface-member/interface-member.vue");
const interfaceRecharge = () => import("@/views/de-product/interface-member/children/interface-recharge/interface-recharge.vue");
const addInterface = () => import("@/views/de-product/interface-member/children/add-interface/add-interface.vue");
const updataInterface = () => import("@/views/de-product/interface-member/children/updata-interface/updata-interface.vue");
const detailsInterface = () => import("@/views/de-product/interface-member/children/details-interface/details-interface.vue");
const interfaceMoneyRecord = () => import("@/views/de-product/interface-member/children/money-record/money-record.vue");
const interfaceBalanceReminder = () => import("@/views/public-page/balance-reminder/balance-reminder.vue");
const interfaceBindSite = () => import("@/views/member-manage/corporate-member-list/children/bind-sites/bind-sites.vue");
const orderSupplement = () => import("@/views/de-product/order-supplement/order-supplement.vue");
const orderSupplementSelectOrder = () => import("@/views/de-product/order-supplement/chileren/select-order.vue");
const thirdPartyServices = () => import("@/views/de-product/third-party-services/third-party-services.vue");
const thirdPartyServicesAdd = () => import("@/views/de-product/third-party-services/children/add-services/add-services.vue");
const thirdPartyServicesUpdata = () => import("@/views/de-product/third-party-services/children/updata-services/updata-services.vue");
const thirdPartyServicesDetails = () => import("@/views/de-product/third-party-services/children/details-services/details-services.vue");
const thirdPartyServicesBindSta = () => import("@/views/de-product/third-party-services/children/bind-sta/bind-sta.vue");
const thirdPlatformPushOrder = () => import("@/views/de-product/third-platform-push-order/third-platform-order.vue");
const routerList = [
    // {
    //   path: "/de-product/msg-server",
    //   name: "短信服务",
    //   component: msgServer,
    //   children: [
    //     {
    //       path: "/de-product/msg-server/msg-buy",
    //       name: "短信购买",
    //       meta: {
    //         nameKey: "msgBuy",
    //       },
    //       component: msgBuy,
    //     },
    //     {
    //       path: "/de-product/msg-server/msg-recharge",
    //       name: "短信条数充值",
    //       component: msgRecharge,
    //       meta: {
    //         nameKey: "msgRecharge",
    //       },
    //     },
    //   ],
    // },
    // {
    //   path: "/de-product/msg-buy-record",
    //   name: "短信购买记录",
    //   component: msgBuyRecord,
    //   children: [
    //     {
    //       path: "/de-product/msg-buy-record/details",
    //       name: "短信购买记录详情",
    //       component: () =>
    //         import(
    //           "@/views/de-product/msg-buy-record/children/msg-buy-record-details/msg-buy-record-details.vue"
    //         ),
    //       meta: {
    //         nameKey: "msgBuyRecordDetails",
    //       },
    //     },
    //     {
    //       path: "/de-product/msg-buy-record/msg-purchase",
    //       name: "短信购买",
    //       component: () =>
    //         import(
    //           "@/views/de-product/msg-buy-record/children/msg-purchase/msg-purchase.vue"
    //         ),
    //       meta: {
    //         nameKey: "msgRecharge",
    //       },
    //     },
    //     {
    //       path: "/de-product/msg-buy-record/msg-apply-invoice",
    //       name: "申请发票",
    //       component: () =>
    //         import(
    //           "@/views/de-product/msg-buy-record/children/msg-apply-invoice/msg-apply-invoice.vue"
    //         ),
    //       meta: {
    //         nameKey: "msgApplyInvoice",
    //       },
    //     },
    //   ],
    // },
    {
        path: "/de-product/interflow",
        name: "互联互通",
        component: interFlow,
    },
    {
        path: "/de-product/interface-member",
        name: "接口会员",
        component: interfaceMember,
        children: [
            {
                path: "/de-product/interface-member/recharge",
                name: "接口会员充值",
                component: interfaceRecharge,
                meta: {
                    nameKey: "interfaceRecharge",
                },
            },
            {
                path: "/de-product/interface-member/add",
                name: "新增接口会员",
                component: addInterface,
                meta: {
                    nameKey: "interfaceAdd",
                },
            },
            {
                path: "/de-product/interface-member/up",
                name: "修改接口会员",
                component: updataInterface,
                meta: {
                    nameKey: "interfaceUp",
                },
            },
            {
                path: "/de-product/interface-member/details",
                name: "接口会员详情",
                component: detailsInterface,
                meta: {
                    nameKey: "interfaceDetails",
                },
            },
            {
                path: "/de-product/interface-member/money-record",
                name: "接口会员资金记录",
                component: interfaceMoneyRecord,
                meta: {
                    nameKey: "interfaceRecord",
                },
            },
            {
                path: "/de-product/interface-member/site",
                name: "接口会员站点",
                component: interfaceBindSite,
                meta: {
                    nameKey: "interfaceSite",
                },
            },
            {
                path: "/de-product/interface-member/balance-reminder",
                name: "接口会员余额提醒",
                component: interfaceBalanceReminder,
                meta: {
                    nameKey: "interfaceBalance",
                },
            },
        ],
    },
    {
        path: "/de-product/order-supplement",
        name: "结算订单补推",
        component: orderSupplement,
        children: [
            {
                path: "/de-product/order-supplement/select-order",
                name: "补推订单",
                component: orderSupplementSelectOrder,
                meta: {
                    nameKey: "supplementOrder",
                },
            },
        ],
    },
    {
        path: "/de-product/third-party-services",
        name: "第三方服务",
        component: thirdPartyServices,
        children: [
            {
                path: "/de-product/third-party-services/add",
                name: "第三方服务申请开通",
                component: thirdPartyServicesAdd,
                meta: {
                    nameKey: "thirdPartyServicesAdd",
                },
            },
            {
                path: "/de-product/third-party-services/updata",
                name: "第三方服务编辑",
                component: thirdPartyServicesUpdata,
                meta: {
                    nameKey: "thirdPartyServicesUp",
                },
            },
            {
                path: "/de-product/third-party-services/details",
                name: "第三方服务详情",
                component: thirdPartyServicesDetails,
                meta: {
                    nameKey: "thirdPartyServicesDetails",
                },
            },
            {
                path: "/de-product/third-party-services/bind-sta",
                name: "第三方",
                component: thirdPartyServicesBindSta,
            },
        ],
    },
    {
        path: "/de-product/third-platform-push-order",
        name: "第三方订单",
        component: thirdPlatformPushOrder,
    },
];
export default routerList;
